var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"contain",style:(_vm.extraStyle)},[_c('div',{staticClass:"line",staticStyle:{"width":"160px"}}),_c('div',{staticClass:"content",style:({width: `${_vm.width}px`})},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"line",staticStyle:{"width":"100%"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }